export enum PaymentGateways {
	STRIPE = "STRIPE",
	RAZORPAY = "RAZORPAY",
	CCAVENUE = "CCAVENUE",
}

export enum Currency {
	AMERICAN_DOLLAR = "USD",
	INDIAN_RUPEES = "INR",
}

export enum CurrencySymbol {
	AMERICAN_DOLLAR = "$",
	INDIAN_RUPEES = "₹",
}

export enum PaymentGatewaysArguments {
	STRIPE = "Stripe",
	RAZORPAY = "Razorpay",
	RAZORPAYMANDATE = "RazorpayMandate",
}
